import React, { useEffect, useState } from "react";
import { BrowserRouter, NavLink, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import WeatherDataPage from "./pages/WeatherDataPage";
import StationInfoPage from "./pages/StationInfoPage";
import DataPlotsPage from "./pages/DataPlotsPage";
import ModelingResultsPage from "./pages/ModelingResultsPage";
import PredictionsPage from "./pages/PredictionsPage";
import { loadDashboardData } from "./services/weatherService";

const navigationItems = [
  { to: "/", label: "Home" },
  { to: "/weather", label: "Weather Data" },
  { to: "/station", label: "Station Info" },
  { to: "/plots", label: "Data Plots" },
  { to: "/results", label: "Results" },
  { to: "/predictions", label: "Predictions" },
];

const App = () => {
  const [dashboardData, setDashboardData] = useState({
    weatherData: null,
    stationInfo: null,
    historicalSeries: null,
    historicalDates: [],
    weatherStatusMessage: null,
  });

  useEffect(() => {
    let isMounted = true;

    const fetchDashboardData = async () => {
      const result = await loadDashboardData();

      if (isMounted) {
        setDashboardData(result);
      }
    };

    fetchDashboardData();

    return () => {
      isMounted = false;
    };
  }, []);

  const { weatherData, stationInfo, historicalSeries, historicalDates, weatherStatusMessage } =
    dashboardData;

  return (
    <BrowserRouter>
      <div className="app-shell">
        <nav className="navbar" aria-label="Primary">
          {navigationItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                isActive ? "navbar-link navbar-link-active" : "navbar-link"
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <main className="page-shell">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/weather"
              element={
                <WeatherDataPage
                  weatherData={weatherData}
                  stationInfo={stationInfo}
                  statusMessage={weatherStatusMessage}
                />
              }
            />
            <Route
              path="/station"
              element={<StationInfoPage stationInfo={stationInfo} statusMessage={weatherStatusMessage} />}
            />
            <Route
              path="/plots"
              element={
                <DataPlotsPage
                  historicalSeries={historicalSeries}
                  historicalDates={historicalDates}
                  statusMessage={weatherStatusMessage}
                />
              }
            />
            <Route path="/results" element={<ModelingResultsPage />} />
            <Route path="/predictions" element={<PredictionsPage />} />
            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
};

export default App;
